import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { useHelpCenterEvents, WidgetType } from '../events/helpCenterEvents'

export const useWidgetHandler = ({
  widgetType,
}: {
  widgetType: WidgetType
}) => {
  const router = useRouter()
  const { widget, ...baseQuery } = router.query

  const { trigger } = useHelpCenterEvents()

  const [chatState, setChatState] = useState<
    'initially-closed' | 'closed' | 'open' | 'open-from-url'
  >(widget ? 'open-from-url' : 'initially-closed')

  useEffect(() => {
    setChatState(widget ? 'open-from-url' : 'initially-closed')
  }, [setChatState, widget])

  useEffect(() => {
    if (chatState.includes('open')) {
      trigger('modalViewed', { modalType: widgetType })

      if (chatState !== 'open-from-url') {
        trigger('click', {
          location: widgetType,
          action: 'Open Chat',
        })
      }
    } else if (chatState === 'closed') {
      trigger('click', {
        location: widgetType,
        action: 'Close Chat',
      })
      router.replace({ query: baseQuery }, undefined, { shallow: true })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chatState, trigger])

  return {
    chatState,
    setChatState,
  }
}
